import { take } from 'ramda';

const take3 = take(3);

export default take3;
